
// import React, { useState, useEffect } from "react";
// import {
//   Dialog,
//   DialogContent,
//   Box,
//   IconButton,
//   Typography,
//   useTheme,
//   useMediaQuery,
//   Button,
//   CircularProgress,
//   Tooltip,
// } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
// import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
// import { BASE_URL } from "../../../services/configUrls";

// const SatffElegantCarousel = ({ onClose = () => {} }) => { // Default function
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [isAnimating, setIsAnimating] = useState(false);
//   const [slides, setSlides] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [hoveredLink, setHoveredLink] = useState(null);

//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("md"));

//   const CANVAS_WIDTH = 320;
//   const CANVAS_HEIGHT = 400;

//   // Fetch posters from API
//   useEffect(() => {
//     const fetchPosters = async () => {
//       try {
//         setLoading(true);
//         const response = await fetch(`${BASE_URL}/documents/usertypePosters`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify({ usertype: "staff" }),
//         });

//         if (!response.ok) {
//           throw new Error("Failed to fetch posters");
//         }

//         const data = await response.json();

//         const transformedSlides = data.map((poster) => {
//           let linkData = null;
//           if (poster.description) {
//             try {
//               linkData = typeof poster.description === 'string' 
//                 ? JSON.parse(poster.description) 
//                 : poster.description;
//             } catch (e) {
//               console.error("Failed to parse description:", e);
//               linkData = null;
//             }
//           }

//           return {
//             image: poster.imageurl,
//             title: poster.heading,
//             description: poster.description,
//             tag: "Poster",
//             posterid: poster.posterid,
//             linkData: linkData,
//           };
//         });

//         setSlides(transformedSlides);
//         setLoading(false);
//       } catch (err) {
//         setError(err.message);
//         setLoading(false);
//       }
//     };

//     fetchPosters();
//   }, []);

//   const isLastSlide = currentSlide === slides.length - 1;

//   const nextSlide = () => {
//     if (isAnimating || isLastSlide) return;
//     setIsAnimating(true);
//     setCurrentSlide((prev) => prev + 1);
//     setTimeout(() => setIsAnimating(false), 500);
//   };

//   const prevSlide = () => {
//     if (isAnimating || currentSlide === 0) return;
//     setIsAnimating(true);
//     setCurrentSlide((prev) => prev - 1);
//     setTimeout(() => setIsAnimating(false), 500);
//   };

//   const handleExit = () => {
//     // Set cookie when user exits
//     document.cookie = "carouselViewed=true; max-age=31536000; path=/";
    
//     // Safe function call
//     if (typeof onClose === 'function') {
//       onClose();
//     } else {
//       console.warn('onClose is not a function, using fallback');
//     }
//   };

//   // Auto-advance slides
//   useEffect(() => {
//     if (slides.length > 1) {
//       const autoAdvanceTimer = setTimeout(() => {
//         if (!isLastSlide) {
//           nextSlide();
//         }
//       }, 4000);

//       return () => clearTimeout(autoAdvanceTimer);
//     }
//   }, [currentSlide, slides.length, isLastSlide]);

//   // Prevent body scroll when modal is open
//   useEffect(() => {
//     document.body.style.overflow = "hidden";
//     return () => {
//       document.body.style.overflow = "unset";
//     };
//   }, []);

//   // Keyboard navigation
//   useEffect(() => {
//     const handleKeyDown = (e) => {
//       if (e.key === "ArrowLeft") prevSlide();
//       if (e.key === "ArrowRight") nextSlide();
//       if (e.key === "Escape") handleExit();
//     };

//     window.addEventListener("keydown", handleKeyDown);
//     return () => window.removeEventListener("keydown", handleKeyDown);
//   }, [isAnimating, currentSlide, isLastSlide]);

//   // Handle link click
//   const handleLinkClick = (e, link) => {
//     e.preventDefault();
//     e.stopPropagation();
//     console.log("Opening link:", link.url);
//     window.open(link.url, "_blank", "noopener,noreferrer");
//   };

//   // Check if current image has links
//   const hasLinks = (image) => {
//     return (
//       image.linkData &&
//       Array.isArray(image.linkData) &&
//       image.linkData.length > 0
//     );
//   };

//   const handleDotClick = (index) => {
//     setCurrentSlide(index);
//   };

//   const handleDialogClose = (event, reason) => {
//     if (reason === "backdropClick" || reason === "escapeKeyDown") {
//       return;
//     }
//     handleExit();
//   };

//   // Don't show anything if no slides available
//   if (!loading && slides.length === 0) {
//     return null;
//   }

//   // Loading state
//   if (loading) {
//     return (
//       <Box
//         sx={{
//           position: "fixed",
//           top: 0,
//           left: 0,
//           width: "100%",
//           height: "100%",
//           display: "flex",
//           justifyContent: "center",
//           alignItems: "center",
//           zIndex: 9999,
//           backgroundColor: "rgba(0, 0, 0, 0.5)",
//         }}
//       >
//         <CircularProgress size={40} color="primary" />
//       </Box>
//     );
//   }

//   // Error state
//   if (error) {
//     return (
//       <Dialog
//         open={true}
//         onClose={handleDialogClose}
//         maxWidth="sm"
//         fullWidth
//         PaperProps={{
//           sx: {
//             backgroundColor: "#000",
//             maxWidth: 300,
//             margin: '20px',
//           },
//         }}
//       >
//         <DialogContent sx={{ padding: 2, textAlign: "center" }}>
//           <Box sx={{ position: "relative" }}>
//             <Button
//               onClick={handleExit}
//               startIcon={<CloseIcon />}
//               variant="contained"
//               sx={{
//                 position: "absolute",
//                 top: -10,
//                 right: -10,
//                 backgroundColor: "#0A507D",
//                 color: "white",
//                 minWidth: 'auto',
//                 padding: '4px 8px',
//                 fontSize: '0.7rem',
//                 "&:hover": {
//                   backgroundColor: "#084068",
//                 },
//               }}
//             >
//               Close
//             </Button>
            
//             <Typography variant="h4" sx={{ color: "white", mb: 1, fontSize: '2rem' }}>
//               ⚠️
//             </Typography>
//             <Typography variant="h6" sx={{ color: "white", mb: 1, fontSize: '1rem' }}>
//               Oops!
//             </Typography>
//             <Typography variant="body1" sx={{ color: "gray.300", mb: 1, fontSize: '0.8rem' }}>
//               Unable to load posters.
//             </Typography>
//             <Typography variant="caption" sx={{ color: "gray.400", fontSize: '0.7rem' }}>
//               {error}
//             </Typography>
//           </Box>
//         </DialogContent>
//       </Dialog>
//     );
//   }

//   const currentImage = slides[currentSlide];
//   const canNavigate = slides.length > 1;

//   return (
//     <Dialog
//       open={true}
//       onClose={handleDialogClose}
//       maxWidth="sm"
//       fullWidth
//       fullScreen={isMobile}
//       disableEscapeKeyDown
//       PaperProps={{
//         sx: {
//           borderRadius: 0,
//           minHeight: isMobile ? "100vh" : 400,
//           maxHeight: isMobile ? "100vh" : 400,
//           width: isMobile ? "100%" : 320,
//           maxWidth: isMobile ? "100%" : 320,
//           backgroundColor: "#000",
//           overflow: "hidden",
//           boxShadow: 'none',
//           border: 'none',
//         },
//       }}
//     >
//       <DialogContent
//         sx={{
//           padding: 0,
//           position: "relative",
//           overflow: "hidden",
//           height: "100%",
//           '&:first-of-type': {
//             padding: 0,
//           },
//         }}
//       >
//         {/* Close button only on last slide */}
//         {isLastSlide && (
//           <Button
//             onClick={handleExit}
//             variant="contained"
//             sx={{
//               position: "absolute",
//               top: 8,
//               right: 8,
//               zIndex: 10,
//               backgroundColor: "#0A507D",
//               color: "white",
//               minWidth: 'auto',
//               padding: '4px 8px',
//               fontSize: '0.7rem',
//               "&:hover": {
//                 backgroundColor: "#084068",
//               },
//               transition: "all 0.3s ease",
//               borderRadius: 1,
//             }}
//           >
//             <CloseIcon />
//           </Button>
//         )}

//         {/* Main Image Container with Links */}
//         <Box
//           sx={{
//             position: "relative",
//             height: "100%",
//             minHeight: isMobile ? "100vh" : 400,
//             width: "100%",
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             backgroundColor: "#f5f5f5",
//           }}
//         >
//           {/* Background Image */}
//           <Box
//             component="img"
//             src={currentImage.image}
//             alt={currentImage.title}
//             loading="eager"
//             sx={{
//               width: "100%",
//               height: "100%",
//               objectFit: "cover",
//               objectPosition: "center",
//               position: "absolute",
//               top: 0,
//               left: 0,
//               zIndex: 1,
//               transition: "opacity 0.5s ease-in-out",
//             }}
//           />

//           {/* Clickable Link Overlays */}
//           {hasLinks(currentImage) &&
//             currentImage.linkData.map((link, index) => {
//               const x = link.x || 0;
//               const y = link.y || 0;
//               const width = link.width || 0;
//               const height = link.height || 0;

//               const leftPercent = (x / CANVAS_WIDTH) * 100;
//               const topPercent = (y / CANVAS_HEIGHT) * 100;
//               const widthPercent = (width / CANVAS_WIDTH) * 100;
//               const heightPercent = (height / CANVAS_HEIGHT) * 100;

//               return (
//                 <Tooltip
//                   key={index}
//                   title={
//                     <Box sx={{ textAlign: "center" }}>
//                       <Typography variant="caption" display="block" fontWeight="bold">
//                         {link.text}
//                       </Typography>
//                       <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
//                         🔗 {link.url}
//                       </Typography>
//                     </Box>
//                   }
//                   arrow
//                   placement="top"
//                 >
//                   <Box
//                     component="a"
//                     href={link.url}
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     onClick={(e) => handleLinkClick(e, link)}
//                     onMouseEnter={() => setHoveredLink(`${currentImage.posterid}-${index}`)}
//                     onMouseLeave={() => setHoveredLink(null)}
//                     sx={{
//                       position: "absolute",
//                       left: `${leftPercent}%`,
//                       top: `${topPercent}%`,
//                       width: `${widthPercent}%`,
//                       height: `${heightPercent}%`,
//                       cursor: "pointer",
//                       zIndex: 5,
//                       border: "none",
//                       backgroundColor:
//                         hoveredLink === `${currentImage.posterid}-${index}`
//                           ? "rgba(25, 118, 210, 0.3)"
//                           : "rgba(25, 118, 210, 0.1)",
//                       transition: "all 0.2s ease",
//                       "&:hover": {
//                         backgroundColor: "rgba(25, 118, 210, 0.4)",
//                       },
//                     }}
//                     aria-label={`Link: ${link.text} - ${link.url}`}
//                   />
//                 </Tooltip>
//               );
//             })}

//           {/* Rest of your component remains the same */}
//           {/* ... navigation, dots, etc. */}
//  <Box
//             sx={{
//               position: "absolute",
//               bottom: 0,
//               left: 0,
//               right: 0,
//               background: "rgba(0, 0, 0, 0.4)",
//               zIndex: 2,
//               height: 60,
//             }}
//           />

//           {/* Navigation Arrows (Desktop/Tablet) */}
//           {!isMobile && canNavigate && (
//             <>
//               <IconButton
//                 onClick={prevSlide}
//                 disabled={isAnimating || currentSlide === 0}
//                 sx={{
//                   position: "absolute",
//                   left: 8,
//                   zIndex: 6,
//                   backgroundColor: "#0A507D",
//                   color: "white",
//                   width: 32,
//                   height: 32,
//                   "&:hover": {
//                     backgroundColor: "#084068",
//                   },
//                   "&:disabled": {
//                     opacity: 0.3,
//                     cursor: "not-allowed",
//                   },
//                   transition: "all 0.3s ease",
//                 }}
//               >
//                 <ArrowBackIosIcon fontSize="small" />
//               </IconButton>

//               <IconButton
//                 onClick={nextSlide}
//                 disabled={isAnimating || isLastSlide}
//                 sx={{
//                   position: "absolute",
//                   right: 8,
//                   zIndex: 6,
//                   backgroundColor: "#0A507D",
//                   color: "white",
//                   width: 32,
//                   height: 32,
//                   "&:hover": {
//                     backgroundColor: "#084068",
//                   },
//                   "&:disabled": {
//                     opacity: 0.3,
//                     cursor: "not-allowed",
//                   },
//                   transition: "all 0.3s ease",
//                 }}
//               >
//                 <ArrowForwardIosIcon fontSize="small" />
//               </IconButton>
//             </>
//           )}

//           {/* Content Overlay */}
//           <Box
//             sx={{
//               position: "absolute",
//               bottom: 0,
//               left: 0,
//               right: 0,
//               padding: "12px",
//               zIndex: 3,
//               textAlign: "center",
//               color: "white",
//             }}
//           >
//             <Box
//               sx={{
//                 display: "flex",
//                 justifyContent: "space-between",
//                 alignItems: "center",
//                 flexDirection: { xs: "column", md: "row" },
//                 gap: { xs: 1.5, md: 0 },
//               }}
//             >
//               {isMobile && canNavigate && (
//                 <Box sx={{ display: "flex", gap: 1, order: { xs: 2, md: 1 } }}>
//                   <IconButton
//                     onClick={prevSlide}
//                     disabled={isAnimating || currentSlide === 0}
//                     sx={{
//                       backgroundColor: "#0A507D",
//                       color: "white",
//                       width: 32,
//                       height: 32,
//                       "&:hover": {
//                         backgroundColor: "#084068",
//                       },
//                       "&:disabled": {
//                         opacity: 0.3,
//                         cursor: "not-allowed",
//                       },
//                     }}
//                   >
//                     <ArrowBackIosIcon fontSize="small" />
//                   </IconButton>

//                   <IconButton
//                     onClick={nextSlide}
//                     disabled={isAnimating || isLastSlide}
//                     sx={{
//                       backgroundColor: "#0A507D",
//                       color: "white",
//                       width: 32,
//                       height: 32,
//                       "&:hover": {
//                         backgroundColor: "#084068",
//                       },
//                       "&:disabled": {
//                         opacity: 0.3,
//                         cursor: "not-allowed",
//                       },
//                     }}
//                   >
//                     <ArrowForwardIosIcon fontSize="small" />
//                   </IconButton>
//                 </Box>
//               )}

//               {/* Progress Dots */}
//               {canNavigate && (
//                 <Box
//                   sx={{
//                     display: "flex",
//                     gap: 0.5,
//                     justifyContent: "center",
//                     order: { xs: 1, md: 2 },
//                   }}
//                 >
//                   {slides.map((_, index) => (
//                     <Box
//                       key={index}
//                       sx={{
//                         width: 6,
//                         height: 6,
//                         borderRadius: "50%",
//                         backgroundColor:
//                           index === currentSlide
//                             ? "#0A507D"
//                             : "rgba(255, 255, 255, 0.5)",
//                         cursor: "pointer",
//                         transition: "all 0.3s ease",
//                         "&:hover": {
//                           backgroundColor: 
//                             index === currentSlide 
//                               ? "#0A507D" 
//                               : "rgba(255, 255, 255, 0.8)",
//                         },
//                       }}
//                       onClick={() => handleDotClick(index)}
//                     />
//                   ))}
//                 </Box>
//               )}

//               {/* Page Count */}
//               <Box sx={{ order: { xs: 3, md: 3 } }}>
//                 <Box
//                   sx={{
//                     padding: "4px 8px",
//                     backgroundColor: "#0A507D",
//                     borderRadius: "4px",
//                   }}
//                 >
//                   <Typography
//                     variant="body2"
//                     sx={{
//                       color: "white",
//                       fontWeight: 500,
//                       fontSize: "0.7rem",
//                     }}
//                   >
//                     {currentSlide + 1} of {slides.length}
//                   </Typography>
//                 </Box>
//               </Box>
//             </Box>
//           </Box>
//         </Box>
//       </DialogContent>
//     </Dialog>
//   );
// };

// export default SatffElegantCarousel;

import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  IconButton,
  Typography,
  useTheme,
  useMediaQuery,
  Button,
  CircularProgress,
  Tooltip,
  Backdrop,
  Zoom,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import { BASE_URL } from "../../../services/configUrls";

const SatffElegantCarousel = ({ onClose = () => {} }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isAnimating, setIsAnimating] = useState(false);
  const [slides, setSlides] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [hoveredLink, setHoveredLink] = useState(null);
  
  // Fullscreen image viewer states
  const [fullscreenOpen, setFullscreenOpen] = useState(false);
  const [fullscreenImageUrl, setFullscreenImageUrl] = useState("");

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const CANVAS_WIDTH = 450;
  const CANVAS_HEIGHT = 600;

  // Fetch posters from API
  useEffect(() => {
    const fetchPosters = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${BASE_URL}/documents/usertypePosters`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ usertype: "staff" }),
        });

        if (!response.ok) {
          throw new Error("Failed to fetch posters");
        }

        const data = await response.json();

        const transformedSlides = data.map((poster) => {
          let linkData = null;
          if (poster.description) {
            try {
              linkData = typeof poster.description === 'string' 
                ? JSON.parse(poster.description) 
                : poster.description;
            } catch (e) {
              console.error("Failed to parse description:", e);
              linkData = null;
            }
          }

          return {
            image: poster.imageurl,
            title: poster.heading,
            description: poster.description,
            tag: "Poster",
            posterid: poster.posterid,
            linkData: linkData,
          };
        });

        setSlides(transformedSlides);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchPosters();
  }, []);

  const isLastSlide = currentSlide === slides.length - 1;

  const nextSlide = () => {
    if (isAnimating || isLastSlide) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => prev + 1);
    setTimeout(() => setIsAnimating(false), 500);
  };

  const prevSlide = () => {
    if (isAnimating || currentSlide === 0) return;
    setIsAnimating(true);
    setCurrentSlide((prev) => prev - 1);
    setTimeout(() => setIsAnimating(false), 500);
  };

  const handleExit = () => {
    // Set cookie when user exits
    document.cookie = "carouselViewed=true; max-age=31536000; path=/";
    
    // Safe function call
    if (typeof onClose === 'function') {
      onClose();
    } else {
      console.warn('onClose is not a function, using fallback');
    }
  };

  // Handle image click for fullscreen view
  const handleImageClick = (e) => {
    // Don't open fullscreen if clicking on a link
    if (e.target.tagName === "A" || e.target.closest("a")) {
      return;
    }
    console.log("Opening fullscreen image viewer");
    setFullscreenImageUrl(currentImage.image);
    setFullscreenOpen(true);
  };

  // Handle fullscreen close
  const handleFullscreenClose = () => {
    console.log("Closing fullscreen image viewer");
    setFullscreenOpen(false);
    setFullscreenImageUrl("");
  };

  // Auto-advance slides
  useEffect(() => {
    if (slides.length > 1 && !fullscreenOpen) {
      const autoAdvanceTimer = setTimeout(() => {
        if (!isLastSlide) {
          nextSlide();
        }
      }, 4000);

      return () => clearTimeout(autoAdvanceTimer);
    }
  }, [currentSlide, slides.length, isLastSlide, fullscreenOpen]);

  // Prevent body scroll when modal is open
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  // Keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "ArrowLeft") prevSlide();
      if (e.key === "ArrowRight") nextSlide();
      if (e.key === "Escape") {
        if (fullscreenOpen) {
          handleFullscreenClose();
        } else {
          handleExit();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isAnimating, currentSlide, isLastSlide, fullscreenOpen]);

  // Handle link click
  const handleLinkClick = (e, link) => {
    e.preventDefault();
    e.stopPropagation();
    console.log("Opening link:", link.url);
    window.open(link.url, "_blank", "noopener,noreferrer");
  };

  // Check if current image has links
  const hasLinks = (image) => {
    return (
      image.linkData &&
      Array.isArray(image.linkData) &&
      image.linkData.length > 0
    );
  };

  const handleDotClick = (index) => {
    setCurrentSlide(index);
  };

  const handleDialogClose = (event, reason) => {
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    handleExit();
  };

  // Don't show anything if no slides available
  if (!loading && slides.length === 0) {
    return null;
  }

  // Loading state
  if (loading) {
    return (
      <Box
        sx={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          zIndex: 9999,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
        }}
      >
        <CircularProgress size={40} color="primary" />
      </Box>
    );
  }

  // Error state
  if (error) {
    return (
      <Dialog
        open={true}
        onClose={handleDialogClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: "#000",
            maxWidth: 600,
            margin: '20px',
          },
        }}
      >
        <DialogContent sx={{ padding: 3, textAlign: "center" }}>
          <Box sx={{ position: "relative" }}>
            <Button
              onClick={handleExit}
              startIcon={<CloseIcon />}
              variant="contained"
              sx={{
                position: "absolute",
                top: -15,
                right: -15,
                backgroundColor: "#0A507D",
                color: "white",
                minWidth: 'auto',
                padding: '8px 16px',
                "&:hover": {
                  backgroundColor: "#084068",
                },
              }}
            >
              Close
            </Button>
            
            <Typography variant="h4" sx={{ color: "white", mb: 2 }}>
              ⚠️
            </Typography>
            <Typography variant="h5" sx={{ color: "white", mb: 2 }}>
              Oops!
            </Typography>
            <Typography variant="body1" sx={{ color: "gray.300", mb: 2 }}>
              Unable to load posters.
            </Typography>
            <Typography variant="caption" sx={{ color: "gray.400" }}>
              {error}
            </Typography>
          </Box>
        </DialogContent>
      </Dialog>
    );
  }

  const currentImage = slides[currentSlide];
  const canNavigate = slides.length > 1;

  return (
    <>
      {/* Main Carousel Dialog */}
      <Dialog
        open={true}
        onClose={handleDialogClose}
        maxWidth={false}
        fullWidth={false}
        fullScreen={isMobile}
        disableEscapeKeyDown
        sx={{
          '& .MuiDialog-container': {
            alignItems: isMobile ? 'stretch' : 'center',
            justifyContent: isMobile ? 'stretch' : 'center',
          },
          '& .MuiDialog-paper': {
            margin: isMobile ? 0 : '32px',
            width: isMobile ? '100%' : '450px',
            height: isMobile ? '100%' : '600px',
            maxWidth: isMobile ? '100%' : '450px',
            maxHeight: isMobile ? '100%' : '600px',
            minWidth: isMobile ? '100%' : '450px',
            minHeight: isMobile ? '100%' : '600px',
          }
        }}
        PaperProps={{
          sx: {
            borderRadius: isMobile ? 0 : 3,
            backgroundColor: "#000",
            overflow: "hidden",
            width: '450px',
            height: '600px',
            maxWidth: '450px',
            maxHeight: '600px',
            minWidth: '450px',
            minHeight: '600px',
            display: 'flex',
            flexDirection: 'column',
            ...(isMobile && {
              width: '100%',
              height: '100%',
              maxWidth: '100%',
              maxHeight: '100%',
              minWidth: '100%',
              minHeight: '100%',
              borderRadius: 0,
            }),
          },
        }}
      >
        <DialogContent
          sx={{
            padding: 0,
            position: "relative",
            overflow: "hidden",
            height: "100%",
            width: "100%",
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Close button only on last slide */}
          {isLastSlide && (
            <Button
              onClick={handleExit}
              startIcon={<CloseIcon />}
              variant="contained"
              sx={{
                position: "absolute",
                top: 16,
                right: 16,
                zIndex: 10,
                backgroundColor: "#0A507D",
                color: "white",
                boxShadow: 3,
                "&:hover": {
                  backgroundColor: "#084068",
                  transform: "scale(1.05)",
                },
                transition: "all 0.3s ease",
                borderRadius: 2,
                padding: '8px 16px',
              }}
            >
              Close
            </Button>
          )}

          {/* Zoom/View Fullscreen Button */}
          <Tooltip title="View Fullscreen" placement="left">
            <IconButton
              onClick={handleImageClick}
              sx={{
                position: "absolute",
                top: 16,
                left: 16,
                zIndex: 10,
                backgroundColor: "rgba(10, 80, 125, 0.9)",
                color: "white",
                boxShadow: 3,
                "&:hover": {
                  backgroundColor: "#084068",
                  transform: "scale(1.1)",
                },
                transition: "all 0.3s ease",
                width: 48,
                height: 48,
              }}
            >
              <ZoomInIcon />
            </IconButton>
          </Tooltip>

          {/* Main Image Container with Links */}
          <Box
            sx={{
              position: "relative",
              height: "100%",
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#000",
              flex: 1,
            }}
          >
            {/* Background Image - Clickable for fullscreen */}
            <Box
              component="img"
              src={currentImage.image}
              alt={currentImage.title}
              loading="eager"
              onClick={handleImageClick}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "contain",
                objectPosition: "center",
                position: "absolute",
                top: 0,
                left: 0,
                zIndex: 1,
                cursor: "zoom-in",
                transition: "opacity 0.5s ease-in-out",
              }}
            />

            {/* Clickable Link Overlays */}
            {hasLinks(currentImage) &&
              currentImage.linkData.map((link, index) => {
                const x = link.x || 0;
                const y = link.y || 0;
                const width = link.width || 0;
                const height = link.height || 0;

                const leftPercent = (x / CANVAS_WIDTH) * 100;
                const topPercent = (y / CANVAS_HEIGHT) * 100;
                const widthPercent = (width / CANVAS_WIDTH) * 100;
                const heightPercent = (height / CANVAS_HEIGHT) * 100;

                return (
                  <Tooltip
                    key={index}
                    title={
                      <Box sx={{ textAlign: "center" }}>
                        <Typography variant="caption" display="block" fontWeight="bold">
                          {link.text || 'Click to open link'}
                        </Typography>
                        {link.url && (
                          <Typography variant="caption" display="block" sx={{ mt: 0.5 }}>
                            🔗 {link.url}
                          </Typography>
                        )}
                      </Box>
                    }
                    arrow
                    placement="top"
                  >
                    <Box
                      component="a"
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      onClick={(e) => handleLinkClick(e, link)}
                      onMouseEnter={() => setHoveredLink(`${currentImage.posterid}-${index}`)}
                      onMouseLeave={() => setHoveredLink(null)}
                      sx={{
                        position: "absolute",
                        left: `${leftPercent}%`,
                        top: `${topPercent}%`,
                        width: `${widthPercent}%`,
                        height: `${heightPercent}%`,
                        cursor: "pointer",
                        zIndex: 5,
                        border:
                          hoveredLink === `${currentImage.posterid}-${index}`
                            ? "2px solid #1976d2"
                            : "2px solid transparent",
                        backgroundColor:
                          hoveredLink === `${currentImage.posterid}-${index}`
                            ? "rgba(25, 118, 210, 0.3)"
                            : "rgba(25, 118, 210, 0.1)",
                        transition: "all 0.2s ease",
                        borderRadius: "4px",
                        "&:hover": {
                          backgroundColor: "rgba(25, 118, 210, 0.4)",
                          transform: "scale(1.02)",
                        },
                      }}
                      aria-label={`Link: ${link.text || link.url}`}
                    />
                  </Tooltip>
                );
              })}

            {/* Clean Bottom Overlay */}
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                background: "linear-gradient(transparent 0%, rgba(0,0,0,0.6) 100%)",
                backdropFilter: "blur(2px)",
                zIndex: 2,
                borderTop: "1px solid rgba(255, 255, 255, 0.1)",
              }}
            />

            {/* Navigation Arrows (Desktop/Tablet) */}
            {!isMobile && canNavigate && (
              <>
                <IconButton
                  onClick={prevSlide}
                  disabled={isAnimating || currentSlide === 0}
                  sx={{
                    position: "absolute",
                    left: 16,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 6,
                    backgroundColor: "#0A507D",
                    color: "white",
                    width: 48,
                    height: 48,
                    boxShadow: 2,
                    "&:hover": {
                      backgroundColor: "#084068",
                      transform: "translateY(-50%) scale(1.1)",
                    },
                    "&:disabled": {
                      opacity: 0.3,
                      cursor: "not-allowed",
                    },
                    transition: "all 0.3s ease",
                  }}
                >
                  <ArrowBackIosIcon />
                </IconButton>

                <IconButton
                  onClick={nextSlide}
                  disabled={isAnimating || isLastSlide}
                  sx={{
                    position: "absolute",
                    right: 16,
                    top: "50%",
                    transform: "translateY(-50%)",
                    zIndex: 6,
                    backgroundColor: "#0A507D",
                    color: "white",
                    width: 48,
                    height: 48,
                    boxShadow: 2,
                    "&:hover": {
                      backgroundColor: "#084068",
                      transform: "translateY(-50%) scale(1.1)",
                    },
                    "&:disabled": {
                      opacity: 0.3,
                      cursor: "not-allowed",
                    },
                    transition: "all 0.3s ease",
                  }}
                >
                  <ArrowForwardIosIcon />
                </IconButton>
              </>
            )}

            {/* Content Overlay */}
            <Box
              sx={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                padding: { xs: "20px", md: "30px" },
                zIndex: 3,
                textAlign: "center",
                color: "white",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  flexDirection: { xs: "column", md: "row" },
                  gap: { xs: 3, md: 0 },
                }}
              >
                {isMobile && canNavigate && (
                  <Box sx={{ display: "flex", gap: 2, order: { xs: 2, md: 1 } }}>
                    <IconButton
                      onClick={prevSlide}
                      disabled={isAnimating || currentSlide === 0}
                      sx={{
                        backgroundColor: "#0A507D",
                        color: "white",
                        width: 48,
                        height: 48,
                        "&:hover": {
                          backgroundColor: "#084068",
                        },
                        "&:disabled": {
                          opacity: 0.3,
                          cursor: "not-allowed",
                        },
                        boxShadow: 2,
                      }}
                    >
                      <ArrowBackIosIcon />
                    </IconButton>

                    <IconButton
                      onClick={nextSlide}
                      disabled={isAnimating || isLastSlide}
                      sx={{
                        backgroundColor: "#0A507D",
                        color: "white",
                        width: 48,
                        height: 48,
                        "&:hover": {
                          backgroundColor: "#084068",
                        },
                        "&:disabled": {
                          opacity: 0.3,
                          cursor: "not-allowed",
                        },
                        boxShadow: 2,
                      }}
                    >
                      <ArrowForwardIosIcon />
                    </IconButton>
                  </Box>
                )}

                {/* Progress Dots - Clean Style */}
                {canNavigate && (
                  <Box
                    sx={{
                      display: "flex",
                      gap: 1.5,
                      justifyContent: "center",
                      order: { xs: 1, md: 2 },
                    }}
                  >
                    {slides.map((_, index) => (
                      <Box
                        key={index}
                        sx={{
                          width: { xs: 10, md: 12 },
                          height: { xs: 10, md: 12 },
                          borderRadius: "50%",
                          backgroundColor:
                            index === currentSlide
                              ? "#0A507D"
                              : "rgba(255, 255, 255, 0.5)",
                          cursor: "pointer",
                          transition: "all 0.3s ease",
                          border: "2px solid rgba(255, 255, 255, 0.3)",
                          transform:
                            index === currentSlide
                              ? "scale(1.3)"
                              : "scale(1)",
                          "&:hover": {
                            backgroundColor:
                              index === currentSlide
                                ? "#0A507D"
                                : "rgba(255, 255, 255, 0.8)",
                            transform: "scale(1.2)",
                          },
                        }}
                        onClick={() => handleDotClick(index)}
                      />
                    ))}
                  </Box>
                )}

                {/* Page Count - Clean Design */}
                <Box sx={{ order: { xs: 3, md: 3 } }}>
                  <Box
                    sx={{
                      padding: { xs: "8px 16px", md: "10px 18px" },
                      backgroundColor: "#0A507D",
                      borderRadius: "8px",
                      border: "1px solid rgba(255, 255, 255, 0.2)",
                      boxShadow: 2,
                    }}
                  >
                    <Typography
                      variant="body2"
                      sx={{
                        color: "white",
                        fontWeight: 500,
                        fontSize: { xs: "0.8rem", md: "0.9rem" },
                      }}
                    >
                      {currentSlide + 1} of {slides.length}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </DialogContent>
      </Dialog>

      {/* Fullscreen Image Viewer Modal - Updated for almost full screen */}
      <Dialog
        open={fullscreenOpen}
        onClose={handleFullscreenClose}
        maxWidth={false}
        fullWidth
        fullScreen
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.98)",
            },
          },
        }}
        sx={{
          zIndex: theme.zIndex.modal + 1,
          '& .MuiDialog-paper': {
            margin: 0,
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            maxHeight: '100%',
            borderRadius: 0,
          }
        }}
      >
        <Zoom in={fullscreenOpen} timeout={500}>
          <DialogContent
            sx={{
              padding: 0,
              position: "relative",
              overflow: "hidden",
              height: "100vh",
              width: "100vw",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#000",
            }}
          >
            {/* Close Fullscreen Button */}
            <IconButton
              onClick={handleFullscreenClose}
              sx={{
                position: "absolute",
                top: 24,
                right: 24,
                zIndex: 10,
                backgroundColor: "rgba(255, 255, 255, 0.95)",
                color: "#000",
                width: 56,
                height: 56,
                boxShadow: 4,
                "&:hover": {
                  backgroundColor: "#fff",
                  transform: "scale(1.1)",
                },
                transition: "all 0.3s ease",
              }}
            >
              <CloseIcon fontSize="large" />
            </IconButton>

            {/* Fullscreen Image - Almost full screen */}
            <Box
              component="img"
              src={fullscreenImageUrl}
              alt={currentImage.title}
              onClick={handleFullscreenClose}
              sx={{
                width: "98vw",
                height: "98vh",
                objectFit: "contain",
                cursor: "zoom-out",
                imageRendering: "high-quality",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "scale(1.01)",
                },
              }}
            />

            {/* Image Title Overlay */}
            {currentImage.title && (
              <Box
                sx={{
                  position: "absolute",
                  bottom: 40,
                  left: "50%",
                  transform: "translateX(-50%)",
                  backgroundColor: "rgba(0, 0, 0, 0.85)",
                  padding: "16px 32px",
                  borderRadius: "12px",
                  maxWidth: "90%",
                  textAlign: "center",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255, 255, 255, 0.1)",
                }}
              >
                <Typography
                  variant="h5"
                  sx={{
                    color: "white",
                    fontWeight: 600,
                    fontSize: { xs: "1rem", md: "1.25rem" },
                  }}
                >
                  {currentImage.title}
                </Typography>
              </Box>
            )}
          </DialogContent>
        </Zoom>
      </Dialog>
    </>
  );
};

export default SatffElegantCarousel;